__turbopack_context__.v({
  "content": "styles-module__ZDSVca__content",
  "icon": "styles-module__ZDSVca__icon",
  "panel": "styles-module__ZDSVca__panel",
});
